import { ContainerModule } from '@evertel/di'
import { ToastService } from './elements'

const DI_WEB_UI_MODULE = new ContainerModule((m) => {
    m.bind(ToastService).toSelf().inSingletonScope()
})

export { DI_WEB_UI_MODULE }
